export class JbsAdminMfaTokenModel {
  hashcode: string;
  token: string;
}
